import { loadOptions } from '../../versa/formset.js';
import db from '../../versa/db.js';

/**
 * Produtos do Pedido de Saída por empresa (mesmo padrão obs_load_options).
 * NÃO filtrar pelo Programa do cabeçalho: no PRD muitos pedidos usam «Padrão»
 * enquanto o estoque/programa do lote é outro (ex. MERCADO LIVRE) — filtrar aqui
 * esvazia a datalist. O saldo simulado continua filtrado por program_id.
 * #MT programa/tenant (regressão 03/09 — lista vazia LLT).
 */
export default function (..._args)
{
	return {
		async actions(_ev, _publisher, _value)
		{
			const company_id = this.locate('company_id')?.getValue?.();
			const listAttr = document.querySelector(this.selector)?.getAttribute('list') || 'products';
			const clear = () =>
			{
				loadOptions(`#${listAttr.replace(/^#/, '')}`, [], 'id', ['sku', 'name']);
				this.refresh?.();
			};
			if (company_id == null || company_id === '' || company_id === -1)
			{
				clear();
				return;
			}
			let data = [];
			try
			{
				data = await db.list(
					'products',
					IDBKeyRange.bound([company_id, ''], [company_id, '\uffff']),
					2,
				) || [];
			}
			catch (_e)
			{
				data = [];
			}
			data = data.filter((r) => !(r.is_disabled === true || r.is_disabled === 1 || r.is_disabled === '1'));
			const dl = listAttr.startsWith('#') ? listAttr : `#${listAttr}`;
			loadOptions(dl, data, 'id', ['sku', 'name']);
			this.refresh?.();
		},
	};
}
